import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, LL_H_C } from '@nu-art/thunderstorm-frontend/index';
import './Header_Editor.scss';
import { TS_EditableItemComponentProto } from '@nu-art/thunderstorm-frontend/components/TS_EditableItemComponent/TS_EditableItemComponent';
export class Header_Editor extends TS_EditableItemComponentProto {
    render() {
        return _jsxs(LL_H_C, { className: 'editor__header', children: [_jsx("div", { className: 'editor__header__title', children: this.props.getTitle() }), this.renderButtons()] });
    }
    renderButton = (button, i) => {
        return _jsx(Button, { variant: button.preferredButton ? 'primary' : 'secondary', className: _className(button.preferredButton ? 'preferred-action' : undefined), onClick: async () => button.action(), children: button.label }, `${i}`);
    };
    renderButtons = () => {
        const item = this.state.editable.item;
        return _jsx(LL_H_C, { className: 'editor__header__buttons', children: (item._id ? this.props.editItemButtons : this.props.createItemButtons).map(this.renderButton) });
    };
}
//# sourceMappingURL=Header_Editor.js.map